import { render, staticRenderFns } from "./BaseProduct.vue?vue&type=template&id=2b9ad3fd&scoped=true&"
import script from "./BaseProduct.vue?vue&type=script&lang=js&"
export * from "./BaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./BaseProduct.vue?vue&type=style&index=0&id=2b9ad3fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ad3fd",
  null
  
)

export default component.exports